<template>
	<wt-selector :options="options" v-model="Value" :disabled="disabled" class="sample-type-selector"></wt-selector>
</template>
<script>
import { sampleType } from 'json/goods-order-options'
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: sampleType
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  }
}
</script>
<style lang="less">
.sample-type-selector{
      .el-input,.el-input__inner{
        height: .4rem !important;
      }
}
</style>
